import React from "react";
import {Routes, Route, Navigate} from "react-router-dom";
import ReportPage from "./reportPage";
import CreateTemplate from "./templatesTab/createTemplate";
import CreateReport from "./reportsTab/createReport";
import ViewReport from "./reportsTab/ViewReport";

const Reports = () => {
  return (
    <Routes>
      <Route path={"*"} element={<Navigate to="/app/reports" />} />
      <Route path={"/"} element={<ReportPage />} />
      <Route path={"/add-template"} element={<CreateTemplate />} />
      <Route path={"/:templateId/edit-template"} element={<CreateTemplate />} />
      <Route path={"/add-report"} element={<CreateReport />} />
      <Route path={"/:reportId/edit-report"} element={<CreateReport />} />
      <Route path={"/:reportId/view-charts"} element={<ViewReport />} />
    </Routes>
  );
};

export default Reports;
